const themeCache = new Map();

export const getThemeByLogo = logoUrl => themeCache.get(logoUrl);

export const setThemeByLogo = (logoUrl, theme) => {
  themeCache.set(logoUrl, theme);
};

export const clearThemeCache = () => {
  themeCache.clear();
};
